import React, { useState } from "react";
import axios from "axios";
import "./login.scss";
import logo from "../../assets/fitoja-logo.jpg"; // Make sure this path is correct
import { useNavigate } from "react-router-dom";
import eyeIconCross from "../../assets/eye_icon_cross.png"; // Make sure this path is correct
import eyeIcon from "../../assets/eye_icon.png"; // Make sure this path is correct

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(""); // Clear previous errors

    try {
      const response = await axios.post(
        "https://api.fitoja.in/api/login-sales-admin-panel",
        {
          email,
          password,
        }
      );
      const { token } = response.data;
      localStorage.setItem("email", email);
      localStorage.setItem("token", token);
      navigate("/dashboard"); // Make sure '/dashboard' is the correct route
    } catch (err) {
      // More specific error handling could be added based on err.response
      setError("Invalid email or password");
      console.error("Login failed:", err);
    }
  };

  return (
    <div className="new-login-container">
      <div className="new-login-card">
        <img src={logo} alt="Fitoja Logo" className="new-login-logo" />
        <div style={{"display": "grid"}}>
          <span style={{fontSize: "30px", fontWeight: "600"}}>Welcome to</span>
          <span style={{fontSize: "30px", fontWeight: "600", marginBottom: "20px"}}>Fitoja Sales Panel</span>
        </div>
        {error && <p className="new-error-message">{error}</p>}
        <form onSubmit={handleSubmit} className="new-login-form">
          <div className="new-input-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="new-login-input"
            />
          </div>
          <div className="new-input-group password-group">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="new-login-input"
            />
            <button
              type="button"
              className="new-eye-icon-btn"
              onClick={togglePasswordVisibility}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <img
                className="new-eye-icon-img"
                src={showPassword ? eyeIconCross : eyeIcon}
                alt={showPassword ? "Hide password" : "Show password"}
              />
            </button>
          </div>
          <button type="submit" className="new-login-btn">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
